export const colorSchemes: {
  default: "light";
  light: "light";
  dark: "dark";
} = {
  default: "light",
  light: "light",
  dark: "dark"
};
